import context from '@truckdown/components-systems';
import { Constants, IUserContext } from '@truckdown/systems';

export const messageEventName = 'show-message';
export const promotionUpdatedEventName = 'promotion-updated';
export const cardUpdatedEventName = 'card-update';

export function showMessage(message: string, messageType: string, dismissable: boolean, autoDismiss: boolean) {
    context.events.emit(messageEventName, {
        message: message,
        messageType: messageType,
        dismissable: dismissable,
        autoDismiss: autoDismiss
    });
}

export function detectCardIcon(number: number) {
    const cardNumber = String(number).replace(/\s/g, '');
    let cardType = '';

    if (/^4\d{12}(\d{3})?$/.test(cardNumber)) {
        cardType = 'faCcVisa';
    } else if (/^5[1-5]\d{14}$/.test(cardNumber)) {
        cardType = 'faCcMastercard';
    } else if (/^3[47]\d{13}$/.test(cardNumber)) {
        cardType = 'faCcAmex';
    } else {
        return ''
    }
    return cardType;
};


export function isCsrOrAdmin() {
    return context.isInRole(Constants.Roles.SystemRole) || context.isInRole(Constants.Roles.CSRRole);
};
